export default __webpack_public_path__ + "static/media/lightweight-brick.6c13ef69.webp";